export default __webpack_public_path__ + "static/media/AntyLucy_21.ed409264.jpg";